import { render } from "./ClientFollowUp.vue?vue&type=template&id=da060f16&scoped=true"
import script from "./ClientFollowUp.vue?vue&type=script&lang=js"
export * from "./ClientFollowUp.vue?vue&type=script&lang=js"

import "./ClientFollowUp.vue?vue&type=style&index=0&id=da060f16&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da060f16"]])

export default __exports__